import { useState } from "react";
import { useNavigate } from "react-router-dom";

const hotWords = ["夜航之港", "潮汐之下", "林知远", "悬疑", "古装"];

export default function SearchBand() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");

  const submit = (value: string) => {
    const kw = value.trim();
    navigate(kw ? `/search?q=${encodeURIComponent(kw)}` : "/search");
  };

  return (
    <section className="relative z-20 mx-auto -mt-8 w-full px-4 md:-mt-10 md:px-8">
      <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-6">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            submit(keyword);
          }}
          className="flex flex-col gap-3 sm:flex-row"
        >
          <div className="flex flex-1 items-center gap-3 rounded-md border border-background-300 bg-background-100 px-4 py-3 transition-colors focus-within:border-primary-400">
            <span className="flex h-5 w-5 items-center justify-center text-foreground-400">
              <i className="ri-search-line text-lg" />
            </span>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="输入影视名称、演员或导演关键词，快速查找资料"
              className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
          </div>
          <button
            type="submit"
            className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-8 py-3 text-sm font-semibold text-primary-950 transition-colors hover:bg-accent-600"
          >
            <i className="ri-search-line text-base" />
            搜索
          </button>
        </form>
        <div className="mt-3 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-fire-line text-accent-500" />
            热门搜索：
          </span>
          {hotWords.map((word) => (
            <button
              key={word}
              type="button"
              onClick={() => submit(word)}
              className="rounded-md bg-background-200 px-2.5 py-1 font-medium text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-700"
            >
              {word}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}